import {ColumnDef} from "@tanstack/react-table"
import {sortableColumnHeader} from "@/components/data-table.tsx"
import {Text} from "@/components/tailwind/text"
import {MemberPhoneListItem} from "@/models/member-phone-list.ts"

export function createPhoneListColumns(): ColumnDef<MemberPhoneListItem>[] {
    return [
        {
            accessorKey: "memberNo",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.memberNo", "reports"),
        },
        {
            accessorKey: "lastName",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.lastName", "reports"),
        },
        {
            accessorKey: "firstName",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.firstName", "reports"),
        },
        {
            accessorKey: "salutation",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.salutation", "reports"),
            cell: ({row}) => <Text>{row.original.salutation ?? "-"}</Text>,
        },
        {
            accessorKey: "district",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.district", "reports"),
            cell: ({row}) => <Text>{row.original.district ?? "-"}</Text>,
        },
        {
            accessorKey: "street",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.street", "reports"),
            cell: ({row}) => <Text>{row.original.street ?? "-"}</Text>,
        },
        {
            accessorKey: "landline",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.landline", "reports"),
            cell: ({row}) => <Text>{row.original.landline ?? "-"}</Text>,
        },
        {
            accessorKey: "mobile",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.mobile", "reports"),
            cell: ({row}) => <Text>{row.original.mobile ?? "-"}</Text>,
        },
        {
            accessorKey: "email",
            header: ({column}) =>
                sortableColumnHeader(column, "phoneList.table.headers.email", "reports"),
            cell: ({row}) => <Text>{row.original.email ?? "-"}</Text>,
        },
    ]
}
